export default __webpack_public_path__ + "static/media/element_23.f7c7d246.webp";